var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    viewBox: "0 0 80 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8301 18.9304L80 12.4392L21.4468 36.8143C11.0255 41.2301 4.26933 40.8769 1.17833 35.7545C0.0301781 34.0765 -0.278882 31.9128 0.251011 29.2634C0.780905 26.6139 1.97317 23.9203 3.82779 21.1825C5.5057 18.6214 8.11106 15.4861 11.6437 11.7769C10.1423 13.9848 9.17084 16.281 8.72931 18.6655C8.0227 22.2864 8.86178 24.9801 11.2463 26.7464C12.3061 27.7178 13.8074 28.2477 15.7504 28.336C17.6933 28.4244 19.9012 28.1152 22.3741 27.4087L46.0868 21.1825H39.4631V12.1743L36.1513 21.1825H30.9848L38.8008 0.119202H43.8348L41.3178 6.34545L46.4842 0.251675H60.6589L59.2017 4.0934H54.8301L53.2404 8.33255L57.7445 8.06761L56.4197 11.9093H51.9156L50.1935 16.9433H55.4924L54.8301 18.9304ZM31.5169 0.119202L23.701 21.1825L18.5345 20.9175L19.1969 10.982L15.3552 21.1825H10.3212L18.1371 0.119202H23.5685L22.7737 9.25987L26.3505 0.119202H31.5169ZM37.6069 0.119202L29.7909 21.1825H24.7569L32.7053 0.119202H37.6069ZM43.97 19.8537L43.7051 9.25585L51.1236 0.645081L43.97 19.8537Z",
    fill: "var(--klothed-textColor)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNike);
export default __webpack_public_path__ + "static/media/logo-nike.4fda5d79dac1322133d1d8484d2b0d06.svg";
export { ForwardRef as ReactComponent };